import { asset, config } from '@/helpers'

const Mixin = {
  methods: {
    /**
     * Generate an asset path for the application.
     */
    asset(path) {
      return asset(path)
    },

    /**
     * Get / set the specified configuration value.
     *
     * If an array is passed as the key, we will assume you want to set an array of values.
     */
    config(key) {
      return config(key)
    },
  },
}

export default Mixin
